import { resolveLocale } from '@outbook/resolve-locale';

export function formatDate({ value, dateStyle = 'medium' }) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return new Intl.DateTimeFormat(resolveLocale(document.documentElement), {
    dateStyle
  }).format(date);
}
